const siteHeader = document.getElementById('site-header');

let lastScrollTop = window.scrollY || document.documentElement.scrollTop;

function showSiteHeader() {
	siteHeader.setAttribute('data-state', 'visible');
}

function hideSiteHeader() {
	siteHeader.setAttribute('data-state', 'hidden');
}

window.addEventListener('scroll', () => {
	const top = window.scrollY || document.documentElement.scrollTop;
	if (Math.abs(top - lastScrollTop) > 10) {
		if (top <= 1) {
			showSiteHeader();
		} else {
			if (top < lastScrollTop) {
				showSiteHeader();
			} else {
				if (popupCart && !popupCart.hidden) return;
				if (popupMenu && !popupMenu.hidden) return;
				hideSiteHeader();
			}
		}

		lastScrollTop = top;
	}
});
